import React, {useState, useEffect , useCallback } from 'react';
import {useScreenSize} from '../../hooks/useScreenSize'; 
import {SocialLinks} from './MenuMobile';
import {useCloseUp} from '../../hooks/useCloseUp';
import {CloseUpOverlay} from './CloseUpOverlay';
import {useElementPositionRef} from '../../hooks/useElementPositionRef';
import SideTab from './SideTab';
import IconAlargamento from '../../../components/images/icons/Search50ftBis.png';
import './themesScreen.scss';

function ThemesScreen({theme, article, paragraphs}) {
    const screenSize = useScreenSize(800);
    const {elementRef, distanceFromTop} = useElementPositionRef();
    const {closeUpState, openCloseUp,  closeCloseUp } = useCloseUp();
    const [widthEffect, setWidthEffect] = useState(false);
    const [scrollPos, setScrollPos] = useState();
        
    const checkIndice = useCallback((id, index, nome) => {
        if (!paragraphs || !Array.isArray(paragraphs)) {
            return;
        }
        const paragrafo = paragraphs.find(p => p.paragraph_id === id);
        if (!paragrafo) {
            return;
        }
        const imageToShow = paragrafo.alargamento?.[index];
        const commentaryToShow = paragrafo.commentary_large?.[index];
        
        if (imageToShow && commentaryToShow) {
            openCloseUp(id, index, nome, imageToShow, commentaryToShow);
        } else {
            if (imageToShow) {
                openCloseUp(id, index, nome || 'No title', imageToShow, commentaryToShow || 'No description');
            }
        }
    }, [paragraphs, openCloseUp]);


    useEffect(() => {
        if(screenSize){
            setWidthEffect(false);
        }else {
            setWidthEffect(true);
        }
    }, [screenSize]);
    

    useEffect(() => {
        setTimeout(() => {
            let top = Math.round(distanceFromTop);
            setScrollPos(top)          
        }, 200);
        
    }, [distanceFromTop, scrollPos])
    
    return (
        <section>
            <div className="container-sotto__tema">
            {scrollPos && <SideTab sizeDiv={scrollPos}/>}
                {paragraphs && 
                <div className="sotto-tema">
                    <SocialLinks/>
                    <div className="ctn-titles">
                        {theme && <h2 className="tema__titolo">{theme.tema_titolo}</h2>}
                        {article && <h1 className="sotto-tema__titolo" dangerouslySetInnerHTML={{ __html: article.articolo_titolo }}/>}
                    </div>
                    <div className="sotto-tema__intro">
                        {article && <p className="linee" dangerouslySetInnerHTML={{ __html: article.intro }}/>}
                    </div>

                    {!widthEffect ? 
                    /* VERSIONE DESKTOP */
                    <div>
                        {paragraphs.map(graf => (
                            <div key={graf.paragraph_id}>
                                {(graf.paragraph_id % 2 === 0) ? 
                                <div className='containtor-paragraph' >
                                    <div className="paragraph-titolo">
                                        <h3 className="titolo" dangerouslySetInnerHTML={{ __html: graf.titolo }}/>
                                    </div>
                                    <div className="paragrafo-articolo">
                                        {graf.line.map((linea, index) => (
                                            <div className="articolo__linee" key={index}>
                                                <p className="linee"  dangerouslySetInnerHTML={{ __html: linea }}/>
                                            </div>
                                        ))} 
                                        {graf.pictures[0] ? 
                                        <div className="paragrafo-img">
                                            {graf.pictures.map((image, indice) => (
                                                <div className='illustrazione__ls' key={indice}>
                                                    <div className="img__ls" >
                                                        {image && <img src={require(`../../../components/images/${image}.png`)} alt="Illustazione dell'articolo" />}
                                                    </div>
                                                    <div className="commentary__ls" onMouseEnter={() => checkIndice(graf.paragraph_id, indice, graf.commentary[indice])}>
                                                        <p dangerouslySetInnerHTML={{ __html: graf.commentary[indice] }} />
                                                        <img src={IconAlargamento} alt="Icon of enlargement"/>
                                                    </div>
                                                </div>
                                            ))}
                                        </div> 
                                        : 
                                        <div className="no-illustrazione__ls"></div>}
                                    </div>
                                </div> 
                                : 
                                <div className='containtor-paragraph' >
                                    <div className="paragraph-titolo">
                                        <h3 className="titolo" dangerouslySetInnerHTML={{ __html: graf.titolo }}/>
                                    </div>
                                    <div className="paragrafo-articolo">
                                        {graf.pictures[0] ? 
                                        <div className="paragrafo-img">
                                            {graf.pictures.map((image, indice) => (
                                                <div className="illustrazione__ls" key={indice}>
                                                    <div className='img__ls'>
                                                        {image && <img  src={require(`../../../components/images/${image}.png`)} alt="Illustazione dell'articolo" />}
                                                    </div>
                                                    <div className="commentary__ls" onMouseEnter={() => checkIndice(graf.paragraph_id, indice, graf.commentary[indice])}>
                                                        <p dangerouslySetInnerHTML={{ __html: graf.commentary[indice] }} />
                                                        <img src={IconAlargamento} alt="Icon of enlargement" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div> 
                                        : 
                                        <div className="no-illustrazione__ls"></div>}
                                        {graf.line.map((linea, index) => (
                                            <div className="articolo__linee" key={index}>
                                                <p className="linee"  dangerouslySetInnerHTML={{ __html: linea }}/>
                                            </div>
                                        ))} 
                                    </div>             
                                </div>}
                            </div> 
                        ))}
                    </div>  
                    :
                    /* VERSIONE MOBILE */
                    <div>
                        {paragraphs.map(graf => ( 
                            <div key={graf.paragraph_id}>
                                <div>
                                    <div className="paragraph-titolo__sscreen">
                                        <h3 className="titolo" dangerouslySetInnerHTML={{ __html: graf.titolo }}/>
                                    </div>
                                    <div className="paragrafo-articolo__sscreen">
                                        {graf.line.map((linea, index) => {
                                            return ( 
                                            <div className="articolo-linee__sscreen" key={index}>
                                                <p className="linee__sscreen"  dangerouslySetInnerHTML={{ __html: linea }}/>
                                            </div>
                                            )
                                        })} 
                                        {graf.pictures[0] ? 
                                        <div className="paragrafo-img__sscreen">
                                            {graf.pictures.map((image, indice) => {
                                            return (
                                                <div className='illustrazione__ss mt-2' key={indice} >
                                                    <div className="img__ss">
                                                        {image && <img className='ss-illust' src={require(`../../../components/images/${image}.png`)}  alt="Illustazione dell'articolo" />}
                                                    </div>
                                                    <div className="commentery__ss mb-20">
                                                        <img 
                                                            src={IconAlargamento} 
                                                            alt="Icon of enlargement" 
                                                            onMouseEnter={() => checkIndice(graf.paragraph_id, indice, graf.commentary[indice])}
                                                        />    
                                                        <p dangerouslySetInnerHTML={{ __html: graf.commentary[indice] }} />
                                                    </div>
                                                </div>
                                                )
                                            })}
                                        </div> 
                                        : 
                                        <div className="no-illustrazione__ss"></div>}
                                    </div>   
                                </div> 
                            </div> 
                        ))}
                    </div>}
                </div>}
                
                {/* CLOSE UP OVERLAY - FUNZIONA SIA SU MOBILE CHE DESKTOP */}
                <CloseUpOverlay
                    isOpen={closeUpState.isOpen}
                    onClose={closeCloseUp}
                    title={closeUpState.title}
                    image={closeUpState.image}
                    commentary={closeUpState.commentary} 
                />
            </div>
            <div className="bottom-ctn" ref={elementRef}></div>
        </section>
    )
}
export default ThemesScreen;
